"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Preview = void 0;
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var axios_1 = __importDefault(require("axios"));
var react_2 = require("@chakra-ui/react");
var PageNotFound_1 = require("../../common/error/PageNotFound");
var ContentLayout_1 = require("../../common/layout/ContentLayout");
var PageLoading_1 = require("../../common/loading/PageLoading");
var Preview = function () {
    var _a = (0, react_1.useState)(), previewData = _a[0], setPreviewData = _a[1];
    var _b = (0, react_1.useState)(true), isPreviewLoading = _b[0], setIsPreviewLoading = _b[1];
    var params = (0, react_router_1.useParams)();
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/preview/" + params.content_template_id)
            .then(function (response) {
            setPreviewData(response.data);
        })
            .finally(function () {
            setIsPreviewLoading(false);
        });
    }, []);
    if (isPreviewLoading)
        return react_1.default.createElement(PageLoading_1.PageLoading, null);
    return (react_1.default.createElement(react_1.default.Fragment, null, (previewData === null || previewData === void 0 ? void 0 : previewData.blocks) ? (react_1.default.createElement(ContentLayout_1.ContentLayout, { contentBlocksData: previewData.blocks })) : (react_1.default.createElement(react_2.Box, { padding: "5rem" },
        react_1.default.createElement(PageNotFound_1.PageNotFound, null)))));
};
exports.Preview = Preview;
